module.exports = __webpack_public_path__ + "6df330897b2f371fc164f4a8136309d7.svg";